import React, { useEffect, useState, useContext } from 'react'
import { DefaultContext } from '../../context/context_default';

import DeckDB from '../../database/wrappers/deck';
export function useDeckList() {

	const {

		showCardFlutuante,

		globalFirestoreData,
		resetaDeck

	} = useContext(DefaultContext);

	const [listDecksUser, setListDecksUser] = useState(null);
	const [deckSelect, setDeckSelect] = useState(null)
	const [isOpenDeck, setIsOpenDeck] = useState(false)
	const [lastDoc, setLastDoc] = useState(null)
	const [hasMore, setHasMore] = useState(true)
	const [loading, setLoading] = useState(false)
	const [isOpenDeleteModal, setIsOpenDeleteModal] = useState(false)
	const [deckToDelete, setDeckToDelete] = useState(null)
	useEffect(() => {
		console.log('globalFirestoreData:', globalFirestoreData);
		if (globalFirestoreData && globalFirestoreData.userId) {
			console.log('Carregando decks para userId:', globalFirestoreData.userId);
			getDecks()
		} else {
			console.log('Usuário não logado ou dados não carregados');
		}
	}, [globalFirestoreData])



	const getDecks = async () => {
		const userDB = new DeckDB()
		if (globalFirestoreData.userId) {
			await userDB.getAll({ orderByField: 'timestamp', field: 'user_id', operator: '==', value: globalFirestoreData.userId }).then((e) => {
				setListDecksUser(e); console.log("-1-", e)
			}).catch(err => {
				console.log("err", err)
			})
		}

	}
	const changeDeck = (deck) => {
		setDeckSelect(deck)
	}
	const toggleDrawerDeck = (valor) => {
		setIsOpenDeck(valor)
	}

	useEffect(() => {
		resetaDeck()
	}, [])


	const estiloCard = {
		top: showCardFlutuante ? `${window.innerHeight * 0.8 > showCardFlutuante?.y ? showCardFlutuante?.y : window.innerHeight * 0.8}px` : '0',

	};

	const loadMoreDecks = () => {
		if (hasMore && !loading) {
			getDecks(true);
		}
	}

	const openDeleteModal = (deck) => {
		setDeckToDelete(deck)
		setIsOpenDeleteModal(true)
	}

	const closeDeleteModal = () => {
		setIsOpenDeleteModal(false)
		setDeckToDelete(null)
	}

	const deleteDeck = async () => {
		if (!deckToDelete) return
		
		try {
			const deckDB = new DeckDB()
			await deckDB.delete(deckToDelete.id)
			
			// Atualizar a lista removendo o deck excluído
			setListDecksUser(prev => prev.filter(deck => deck.id !== deckToDelete.id))
			
			// Fechar o drawer se o deck excluído estava selecionado
			if (deckSelect?.id === deckToDelete.id) {
				setIsOpenDeck(false)
				setDeckSelect(null)
			}
			
			closeDeleteModal()
		} catch (error) {
			console.error('Erro ao excluir deck:', error)
		}
	}

	return {
		listDecksUser,
		deckSelect,
		setDeckSelect,
		changeDeck,
		isOpenDeck,
		toggleDrawerDeck,
		estiloCard,
		loadMoreDecks,
		hasMore,
		loading,
		isOpenDeleteModal,
		deckToDelete,
		openDeleteModal,
		closeDeleteModal,
		deleteDeck
	}
}
